"use client";

import { withFallback } from "../with-fallback";

export const ChatElement = withFallback<"chat-element", true>({
	displayName: "ChatElement",
	type: "chat-element",
});
